module.exports = __webpack_public_path__ + "img/nie-connection-confi-md.473c4745.png";